import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="assignments"
                icon="faPerson"
                dataProviderName={'statisticsviews/item/count/cars/pool'}
            />
            <KPI
                title="Active drivers"
                icon="faPeople"
                dataProviderName={'statisticsviews/active/count/cars/pool'}
                filters={{
                    'items': [
                        {
                            'field': 'assignment_start_at',
                            'operator': 'before',
                            'value': new Date().toISOString()
                        },
                        {
                            'field': 'assignment_end_at',
                            'operator': 'afterOrNull',
                            'value': new Date().toISOString()
                        }
                    ]
                }}
            />
            <KPI
                title="Vehicles"
                icon="faCar"
                dataProviderName={'statisticsviews/item/count/cars/car'}
            />
        </Box>
        <List />
    </>,[])

}

export default Default;


